class Transitions {
    constructor() {
        this.scopeContexts = new Map();
        this.init();
    }

    init() {
        if (!document.body.classList.contains('gfq')) {
            this.bindColorScroll();
        }

        const menuOutils = document.querySelector(".menu-outils");
        if (menuOutils) {
            ScrollTrigger.observe({
                target: window,
                type: "wheel,touch",
                onDown: () => {
                    if (window.scrollY > window.innerHeight * 0.5 && !menuOutils.classList.contains("hide")) {
                        gsap.to(menuOutils, { y: -50, alpha: 0, duration: 0.3, ease: "power3.in", overwrite: true });
                        menuOutils.classList.add("hide");
                    }
                },
                onUp: () => {
                    if (menuOutils.classList.contains("hide")) {
                        gsap.to(menuOutils, { y: 0, alpha: 1, duration: 0.6, ease: "power3.out", overwrite: true });
                        menuOutils.classList.remove("hide");
                    }
                }
            });
        }

        if (window.scrollY >= 100 && document.querySelector(".logo-alternatif-container")) {
            const gfqMark = document.querySelector(".menu-outils-gfq");
            if (gfqMark) gsap.set(gfqMark, { y: 30, autoAlpha: 0 });
        }

        setTimeout(() => {

            const bigLogo = document.querySelector(".logo-alternatif-container");
            const smallLogo = document.querySelector(".header .logo-alternatif .logo");

            if (bigLogo) {
                const logoTrigger = ".main-container > div:nth-child(2)";
                const logoStart = "top 100%-=200px";
                const gfqMark = document.querySelector(".menu-outils-gfq");
                let logoPlayed = false;

                const revealGfqMark = () => {
                    if (!gfqMark || gfqMark.classList.contains("is-in")) return;
                    if (!window.matchMedia("(max-width: 768px)").matches) return;
                    gsap.to(gfqMark, {
                        autoAlpha: 1,
                        duration: 0.45,
                        ease: "power3.out",
                        overwrite: true,
                        onComplete: () => {
                            gfqMark.classList.add("is-in");
                            gsap.set(gfqMark, { clearProps: "opacity,visibility" });
                        }
                    });
                };

                const playHeaderLogo = () => {
                    if (logoPlayed) return;
                    logoPlayed = true;

                    gsap.to(bigLogo, {
                        y: -60,
                        ease: "power3.in",
                        alpha: 0,
                        duration: 0.4,
                        display: "none",
                        onComplete: () => {
                            gsap.to("header", { mixBlendMode: "exclusion", duration: 0.5 });
                            if (!smallLogo) revealGfqMark();
                        }
                    });

                    if (smallLogo) {
                        gsap.to(smallLogo, {
                            duration: 0.6,
                            y: 0,
                            alpha: 1,
                            ease: "power3.out",
                            delay: 0.4,
                            onStart: () => { gsap.to("header", { mixBlendMode: "exclusion", duration: 0.5 }); },
                            onComplete: revealGfqMark
                        });
                    }
                };

                if (window.scrollY < 100) {
                    gsap.set(bigLogo, { display: "block" });
                    if (smallLogo) gsap.set(smallLogo, { y: 30 });

                    ScrollTrigger.create({
                        trigger: logoTrigger,
                        start: logoStart,
                        onEnter: playHeaderLogo
                    });

                    setTimeout(playHeaderLogo, 1200);
                } else {
                    gsap.set(bigLogo, { display: "none" });

                    if (smallLogo) {
                        gsap.set(smallLogo, { y: 30 });
                        gsap.to(smallLogo, {
                            duration: 0.6,
                            y: 0,
                            alpha: 1,
                            ease: "power3.out",
                            delay: 0.4,
                            scrollTrigger: {
                                trigger: logoTrigger,
                                start: logoStart,
                                toggleActions: "play none play none"
                            },
                            onStart: () => { gsap.to("header", { mixBlendMode: "exclusion", duration: 0.5 }); }
                        });
                    }

                    if (gfqMark) {
                        gsap.set(gfqMark, { y: 30, autoAlpha: 0 });
                        gsap.to(gfqMark, {
                            duration: 0.6,
                            y: 0,
                            autoAlpha: 1,
                            ease: "power3.out",
                            delay: 0.6,
                            scrollTrigger: {
                                trigger: logoTrigger,
                                start: logoStart,
                                toggleActions: "play none play none"
                            },
                            onComplete: () => {
                                gfqMark.classList.add("is-in");
                                gsap.set(gfqMark, { clearProps: "opacity,visibility,transform" });
                            }
                        });
                    }
                }

            } else {

                if (document.querySelector(".header .logo-normal .logo")) {

                    if (document.querySelector(".hero-container.bordure-1") && document.querySelector(".row_hero").dataset.bgcolor == "white") {
                        gsap.set("header", { mixBlendMode: "exclusion" });
                    } else {

                        gsap.to(".header", {
                            duration: 0.2,
                            alpha: 0,
                            ease: "",
                            scrollTrigger: {
                                trigger: ".main-container > div:nth-child(2)",
                                start: "top top",
                                toggleActions: "play none play none"
                            },
                            onComplete: () => {
                                gsap.set("header", { mixBlendMode: "exclusion" });
                                gsap.to("header", { alpha: 1, duration: 0.8, ease: "expo.out" });
                            }
                        });
                    }
                }
            }
        }, 50);

        this.bindScrollAnimations();

        if (!document.body.classList.contains('gfq')) {
            gsap.from(".row:nth-child(2)", {
                autoAlpha: 0,
                duration: 1,
                y: 20,
                ease: "power3.out",
            });
        }

        this.bindBtnHover();
    }

    bindColorScroll() {
        const sections = document.querySelectorAll('.main-container > .row, footer');
        const colors = Array.from(sections).map((row) => row.getAttribute('data-bgcolor'));

        sections.forEach((row, i) => {
            ScrollTrigger.create({
                trigger: row,
                start: 'top bottom',
                end: 'bottom bottom',
                scrub: true,
                onUpdate: (self) => {
                    const from = this.getColor(i > 0 ? colors[i - 1] : colors[0]);
                    const to = this.getColor(colors[i]);
                    if (!from || !to) return;

                    const currentColor = gsap.utils.interpolate(from, to, self.progress);
                    if (typeof currentColor !== 'string') return;

                    const footer = document.querySelector('footer');
                    if (footer) footer.style.backgroundColor = currentColor;
                    const second = document.querySelector('.main-container > div:nth-child(2)');
                    if (second) second.style.backgroundColor = currentColor;
                    const main = document.querySelector('main');
                    if (main) main.style.backgroundColor = currentColor;
                    gsap.set('.main-container > .row', { backgroundColor: currentColor });
                }
            });
        });
    }

    // Anims scroll — relançables sur un scope (ex. .fiches-content après AJAX)
    bindScrollAnimations() {
        let d = 0;
        const mm = gsap.matchMedia();
        const skipAccordeonContent = (el) => !!el.closest('.accordeon-panel, .row_form');

        let blocs = gsap.utils.toArray(".row_texts.flip-box.encadre-1 .texts-container, .row_image.flip-box .image-container, .row_liste_initiatives .item .item-container, .row_liste_nouvelles .item .item-container, .flipV");
        blocs.forEach(bloc => {
            if (skipAccordeonContent(bloc)) return;
            gsap.set(bloc, { transformStyle: "preserve-3d", transformOrigin: "50% 0%" });
            gsap.from(bloc, {
                autoAlpha: 0,
                duration: 1,
                y: 50,
                z: 0,
                rotationX: -20,
                ease: "power3.out",
                scrollTrigger: {
                    invalidateOnRefresh: false,
                    trigger: bloc,
                    start: "center 90%",
                    toggleActions: "play none play none"
                },
            });
        });

        let blocsH = gsap.utils.toArray(".text-image-content .text-img .bg-img, .flipH, .equipe-img .bg-img-container, .equipe-img .equipe-info-container");
        blocsH.forEach(bloc => {
            if (skipAccordeonContent(bloc)) return;
            var delay = 0;
            if (bloc.classList.contains("delay-2")) {
                delay = 0.2;
            }
            gsap.set(bloc, { transformStyle: "preserve-3d", transformOrigin: "0% 50%" });
            gsap.from(bloc, {
                autoAlpha: 0,
                duration: 1,
                x: 50,
                z: 0,
                delay: delay,
                rotationY: 20,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: bloc,
                    start: "center 90%",
                    toggleActions: "play none play none"
                },
            });
        });

        let blocsHVignettes = gsap.utils.toArray(".mode-vignette .text");
        mm.add("(min-width: 768px)", () => {
            d = 0;
            blocsHVignettes.forEach(bloc => {
                if (skipAccordeonContent(bloc)) return;
                gsap.set(bloc, { transformStyle: "preserve-3d", transformOrigin: "0% 50%" });
                gsap.from(bloc, {
                    autoAlpha: 0,
                    duration: 1,
                    x: 50,
                    z: 0,
                    rotationY: 20,
                    ease: "power3.out",
                    delay: d,
                    scrollTrigger: {
                        trigger: bloc,
                        start: "top 75%",
                        toggleActions: "play none play none"
                    },
                });
                d += 0.1;
            });
        });

        mm.add("(max-width: 768px)", () => {
            blocsHVignettes.forEach(bloc => {
                if (skipAccordeonContent(bloc)) return;
                gsap.from(bloc, {
                    autoAlpha: 0,
                    duration: 1,
                    y: 20,
                    ease: "power3.out",
                    delay: d,
                    scrollTrigger: {
                        trigger: bloc,
                        start: "top 95%",
                        toggleActions: "play none play none"
                    }
                });
            });
        });

        let vignettes = gsap.utils.toArray(".vignettes > div");
        d = 0;
        vignettes.forEach(vignette => {
            if (skipAccordeonContent(vignette)) return;
            gsap.set(vignette, { transformStyle: "preserve-3d", transformOrigin: "50% 0%" });
            gsap.from(vignette, {
                autoAlpha: 0,
                duration: 1,
                y: 50,
                z: 0,
                rotationX: -20,
                ease: "power3.out",
                delay: 0.2 + d,
                scrollTrigger: {
                    trigger: vignette,
                    start: "top 90%",
                    toggleActions: "play none play none"
                },
            });
            d += 0.085;
        });

        let stats = gsap.utils.toArray(".stats-container > div");
        d = 0;
        stats.forEach(stat => {
            if (skipAccordeonContent(stat)) return;
            gsap.set(stat, { transformStyle: "preserve-3d", transformOrigin: "50% 0%" });
            gsap.from(stat, {
                autoAlpha: 0,
                duration: 1,
                y: 50,
                z: 0,
                rotationX: -20,
                ease: "power3.out",
                delay: 0.2 + d,
                scrollTrigger: {
                    trigger: stat,
                    start: "top 90%",
                    toggleActions: "play none play none"
                },
            });
            d += 0.085;
        });

        let etiquettes = gsap.utils.toArray(".row_etiquettes.style-etiquettes li");
        d = 0;
        etiquettes.forEach(el => {
            if (skipAccordeonContent(el)) return;
            gsap.set(el, { transformStyle: "preserve-3d", transformOrigin: "50% 0%" });
            gsap.from(el, {
                autoAlpha: 0,
                duration: 1,
                y: 50,
                z: 0,
                rotationX: -20,
                ease: "power3.out",
                delay: 0.2 + d,
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    toggleActions: "play none play none"
                },
            });
            d += 0.085;
        });

        let textFlips = gsap.utils.toArray(".text-flip, .text-content h2, .text-content h3, body.gfq .text-content h1");
        textFlips.forEach(textFlip => {
            if (skipAccordeonContent(textFlip)) return;
            if (textFlip.closest('.gfq-overlay')) return;
            if (textFlip.parentNode && textFlip.parentNode.classList.contains('text-flip-parent')) {
                return;
            }

            let textFlipParent = document.createElement("div");
            textFlipParent.classList.add("text-flip-parent");
            textFlip.parentNode.insertBefore(textFlipParent, textFlip);
            textFlipParent.appendChild(textFlip);

            gsap.set(textFlip, { transformOrigin: "50% 0% -50px" });
            gsap.from(textFlip, {
                autoAlpha: 0,
                duration: 1,
                y: 50,
                z: 0,
                rotationX: -20,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: textFlip,
                    start: "top 94%",
                    toggleActions: "play none play none"
                }
            });
        });

        let caroussels = gsap.utils.toArray(".carrousel-content");
        caroussels.forEach(caroussel => {
            if (skipAccordeonContent(caroussel)) return;
            gsap.from(caroussel, {
                autoAlpha: 0,
                duration: 0.8,
                x: 200,
                ease: "power2.inOut",
                scrollTrigger: {
                    trigger: caroussel,
                    start: "top 90%",
                    toggleActions: "play none play none"
                },
            });
        });

        let jeuxSlider = gsap.utils.toArray(".jeux-slider-container");
        jeuxSlider.forEach(jeuSlider => {
            if (skipAccordeonContent(jeuSlider)) return;
            gsap.from(jeuSlider, {
                autoAlpha: 0,
                duration: 1,
                delay: 0.2,
                x: 80,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: jeuSlider,
                    start: "center 90%",
                    toggleActions: "play none play none"
                },
            });
        });

        let textsTop = gsap.utils.toArray(".text-content ul li, .text-top, .mode-normal .text-content p, .row_hero .text-content p, .mode-normal .text-content a, .text-image-content .text-content > p, .row_nouvelle h4, .row_nouvelle h5, .text-content h6, .row_nouvelle p, .row_nouvelle li, .single-initiative .text-content li, .single-partenaire .header-membre li, .text-content h4, .text-content h6");
        textsTop.forEach(textTop => {
            if (skipAccordeonContent(textTop)) return;

            var delay = 0;
            if (textTop.classList.contains("delay-1")) {
                delay = 0.1;
            }
            if (textTop.classList.contains("delay-2")) {
                delay = 0.2;
            }
            if (textTop.classList.contains("delay-3")) {
                delay = 0.3;
            }

            gsap.from(textTop, {
                autoAlpha: 0,
                duration: 1,
                y: 20,
                ease: "power3.out",
                delay: delay,
                scrollTrigger: {
                    trigger: textTop,
                    start: "top 95%",
                    toggleActions: "play none play none"
                }
            });
        });

        let fades = gsap.utils.toArray(".fade-in, .partenaire-content ul li");
        fades.forEach(fade => {
            if (skipAccordeonContent(fade)) return;

            var delay = 0;
            if (fade.classList.contains("delay-1")) {
                delay = 0.1;
            }
            if (fade.classList.contains("delay-2")) {
                delay = 0.2;
            }

            gsap.from(fade, {
                autoAlpha: 0,
                duration: 1.5,
                delay: delay,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: fade,
                    start: "top 90%",
                    toggleActions: "play none play none"
                }
            });
        });
    }

    bindBtnHover(scope = document) {
        let btnHover = gsap.utils.toArray(scope.querySelectorAll(".btn, footer .menu li a, header .menu li a, .gfq-lang, .btn-large"));
        if (scope !== document) {
            btnHover = gsap.utils.toArray(scope.querySelectorAll(".btn, .btn-large"));
        }

        btnHover.forEach(btn => {
            if (btn.classList.contains('btn-hover')) return;

            let label = btn.innerHTML;
            btn.innerHTML = "<span class='label-in'>" + label + "</span><span class='label-out'>" + label + "</span>";
            btn.classList.add("btn-hover");

            btn.addEventListener("mouseenter", function () {
                gsap.to(btn.querySelector(".label-in"), { duration: 1, yPercent: -100, ease: "expo.out", overwrite: true });
                gsap.to(btn.querySelector(".label-out"), { duration: 1, yPercent: -100, ease: "expo.out", overwrite: true });
            });

            btn.addEventListener("mouseleave", function () {
                gsap.to(btn.querySelector(".label-in"), { duration: 0.8, yPercent: 0, ease: "expo.out", overwrite: true });
                gsap.to(btn.querySelector(".label-out"), { duration: 0.8, yPercent: 0, ease: "expo.out", overwrite: true });
            });
        });
    }

    refreshScope(scope) {
        if (!scope) return;

        ScrollTrigger.getAll().forEach((st) => {
            if (st.trigger && scope.contains(st.trigger)) {
                st.kill();
            }
        });

        if (this.scopeContexts.has(scope)) {
            this.scopeContexts.get(scope).revert();
            this.scopeContexts.delete(scope);
        }

        const ctx = gsap.context(() => {
            this.bindScrollAnimations();
            this.bindBtnHover(scope);
        }, scope);

        this.scopeContexts.set(scope, ctx);
        ScrollTrigger.refresh();
    }

    getColor(color) {
        if (!color || typeof color !== 'string') return null;
        if (color.charAt(0) === '#') return color;

        switch (color) {
            case 'blue': return '#2341C1';
            case 'white': return '#EEF3FA';
            case 'green': return '#00BFB6';
            case 'darkgreen': return '#005450';
            case 'mauve': return '#BFACE7';
            case 'yellow': return '#F7FA73';
            case 'noir': return '#1E1E1E';
            default: return null;
        }
    }

}

export default Transitions;
